import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FiservCardInterface, FiservCardStatusEnum } from '@common-fe/common-fe';

import { ModalWrapper } from '@/components/wrappers';
import { useCardAccessModal } from '@/modules/transaction/components/Cards/components/CardAccessModal/hooks';
import { useChangeCardStatusQuery } from '@/modules/transaction/queries/useChangeCardStatus.query';

import { CardAccessConfirmationModal } from './CardAccessConfirmationModal';
import CardAccessFormModal from './CardAccessFormModal';

interface Props {
  card?: FiservCardInterface;
  visible: boolean;
  onChangeCardAccessModalVisible?: () => void;
  onHideVisibility?: (value: boolean) => void;
  refreshCardList?: () => void;
}

export const CardAccessModal: React.FC<Props> = ({
  card,
  visible,
  onHideVisibility,
  onChangeCardAccessModalVisible,
  refreshCardList,
}) => {
  const { t } = useTranslation();
  const {
    isConfirmationMode,
    lockedPursesIds,
    isCardLocked,
    handleSetConfirmationMode,
    handleCancel,
  } = useCardAccessModal(card, visible, onChangeCardAccessModalVisible, onHideVisibility);
  const {
    mutateAsync: changeStatusMutation,
    isLoading,
  } = useChangeCardStatusQuery();

  const handleChangeStatusMutationHandler = useCallback(async (status: FiservCardStatusEnum) => {
    if (card) {
      await changeStatusMutation({ id: card?.id, status, lockedPursesIds });
      handleCancel();
      setTimeout(() => refreshCardList?.(), 500);
    }
  }, [card, lockedPursesIds, changeStatusMutation, handleCancel, refreshCardList]);

  return (
    <>
      {!isConfirmationMode
        ? (
          <ModalWrapper testId="ModalWrapper" visible={visible} onSetVisible={handleCancel} title={t('Update Card Access')}>
            <CardAccessFormModal
              lockedPursesIds={lockedPursesIds}
              card={card}
              isCardLocked={isCardLocked}
              isLoading={isLoading}
              onChangeStatusMutationHandler={handleChangeStatusMutationHandler}
              onCancel={handleCancel}
              onSetConfirmationMode={handleSetConfirmationMode}
            />
          </ModalWrapper>
        )
        : (
          <ModalWrapper testId="ModalWrapper" visible={visible} onSetVisible={handleCancel} title={t('Confirm Accounts Lock')}>
            <CardAccessConfirmationModal
              lockedPursesIds={lockedPursesIds}
              card={card}
              isCardLocked={isCardLocked}
              isLoading={isLoading}
              onChangeStatusMutationHandler={handleChangeStatusMutationHandler}
              onCancel={handleCancel}
            />
          </ModalWrapper>
        )}
    </>
  );
};
